"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOverrides = void 0;
var componentOverrides = __importStar(require("./overrides"));
var utils_1 = require("@material-ui/utils");
var keyRegex = /create(\w+)Override/;
var getOverrideKey = function (override) {
    var result = keyRegex.exec(override);
    return result && result[1];
};
var createOverrides = function (theme, options) {
    if (options === void 0) { options = {}; }
    var defaultOverrides = Object.entries(componentOverrides).reduce(function (prev, _a) {
        var _b;
        var key = _a[0], getStyles = _a[1];
        var overrideKey = getOverrideKey(key);
        if (!overrideKey)
            return prev;
        return __assign(__assign({}, prev), (_b = {}, _b[overrideKey] = getStyles(theme), _b));
    }, {});
    var customOverrides = typeof options === "function" ? options(theme) : options;
    return utils_1.deepmerge(defaultOverrides, customOverrides, { clone: false });
};
exports.createOverrides = createOverrides;
//# sourceMappingURL=createOverrides.js.map